const formatPercent = value => {
  if (value === null ||
    value === undefined ||
    value === '') return null

  return parseFloat(value).toFixed(2) + '%'
}

export default formatPercent
